<!-- 提交文章 -->
<template>
  <div class="sub-news">
    <div class="base-info">
      <el-form ref="formMain" :model="formData" :show-message="false">
        <el-descriptions class="" :column="2" border>
          <el-descriptions-item>
            <template slot="label">
              新闻标题
            </template>
            <el-form-item prop="title" required class="mb-0">
              <el-input v-model="formData.title"></el-input>
            </el-form-item>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              作者
            </template>
            <el-form-item prop="author" required class="mb-0">
              <el-input v-model="formData.author"></el-input>
            </el-form-item>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              文章类别
            </template>
            <el-form-item prop="newsLabel" required class="mb-0">
              <el-select v-model="formData.newsLabel" class="w-100">
                <el-option
                  v-for="(item, index) in articleType"
                  :key="index"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              文章标签
            </template>
            <el-form-item prop="labelId" required class="mb-0">
              <el-select v-model="formData.labelId" multiple class="w-100">
                <el-option
                  v-for="(item, index) in articleTag"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              文章主图
            </template>
            <el-form-item prop="picUrl" required class="mb-0">
              <el-upload
                class="avatar-uploader"
                :action="`${$store.state.apiUrlZero}/TuZero/uploadOss`"
                :show-file-list="false"
                :on-success="uploadSuccess"
                :before-upload="beforeUp"
              >
                <img
                  v-if="formData.picUrl"
                  :src="formData.picUrl"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              文章摘要
            </template>
            <el-form-item prop="outline" required class="mb-0">
              <el-input
                type="textarea"
                :rows="5"
                v-model="formData.outline"
              ></el-input>
            </el-form-item>
          </el-descriptions-item>
        </el-descriptions>
      </el-form>
    </div>
    <div class="text-content">
      <!-- <tinymce-editor :init="init" v-model="formData.article"></tinymce-editor> -->
      <div style="border: 1px solid #ccc;">
        <Toolbar
          style="border-bottom: 1px solid #ccc"
          :editor="editor"
          :defaultConfig="toolbarConfig"
          :mode="mode"
        />
        <Editor
          style="height: 500px; overflow-y: hidden;"
          v-model="formData.article"
          :defaultConfig="editorConfig"
          :mode="mode"
          @onCreated="onCreated"
        />
      </div>
    </div>
    <div class="btn-box">
      <div class="release">
        <span>发布时间：</span>
        <el-date-picker
          type="date"
          value-format="yyyy-MM-dd"
          v-model="formData.issueTime"
        ></el-date-picker>
      </div>
      <el-button @click="subArticle" type="success">发布</el-button>
      <el-button @click="resetHandle" type="danger">清空内容</el-button>
    </div>
  </div>
</template>

<script>
// import Editor from "@tinymce/tinymce-vue";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";

import axios from "axios";

export default {
  name: "tuZero_new",
  data() {
    return {
      formData: {
        title: "",
        picUrl: "",
        author: "",
        newsLabel: "", // 文章类别
        outline: "", // 文章摘要
        article: "", // 文章内容
        labelId: [], // 标签
        issueTime: "", // 发布时间
      },
      init: {
        language_url:
          "https://cdn.jsdelivr.net/gh/wt-sml/wutong_cdn/js/tinymce-lang-zh@5.2.2.js",
        language: "zh_CN",
        statusbar: false,
        height: 430,
        plugins:
          "link lists image code table colorpicker textcolor wordcount contextmenu",
        toolbar:
          "bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify|bullist numlist |outdent indent blockquote | undo redo | link unlink image | removeformat",
        menubar: false, // 隐藏最上方menu
        branding: false,
        images_upload_handler: (blobInfo, success, failure) => {
          success("data:image/jpeg;base64," + blobInfo.base64());
        },
      },
      articleType: ["产品资讯", "行业新闻", "企业动态"],
      articleTag: [], // 文章标签

      // 新富文本编辑器
      editor: null,
      html: "",
      toolbarConfig: {},
      editorConfig: {
        placeholder: "思秋，你又开始发水文了？？？",
        MENU_CONF: {
          uploadImage: {
            // 服务器端地址
            server: `${this.$store.state.apiUrlZero}/TuZero/uploadOss`,
            fieldName: "file",
            allowedFileTypes: ["image/*"],
            maxFileSize: 2 * 1024 * 1024, // 2M
            customInsert: function(res, insertFn) {
              insertFn(res.data);
            },
            base64LimitSize: 5 * 1024, // 小于5kb，就会使用base64格式上传
          },
        },
      },
      mode: "default", // or 'simple'
    };
  },
  computed: {},
  components: {
    // "tinymce-editor": Editor,
    Editor,
    Toolbar,
  },
  created() {
    let info = { ...this.$route.query };
    if (info.sign) {
      Object.keys(this.formData).forEach((key) => {
        if (key == "labelId") {
          this.formData.labelId = (info.labelId
            ? info.labelId.split(",")
            : []
          ).map((item) => Number(item));
        } else {
          this.formData[key] = info[key];
        }
      });
      this.getIDDetail(info.newsArticleId);
    }
    this.getTag();
    this.formData.issueTime = this.getNowTime();
  },
  mounted() {
    this.onCreated();
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    getNowTime() {
      let date = new Date();
      let month = date.getMonth() + 1; // 月
      let day = date.getDate(); // 日
      // 当前时间
      let curTime = date.getFullYear() + "-" + month + "-" + day;
      return curTime;
    },
    resetHandle() {
      Object.keys(this.formData).forEach((key) => {
        this.formData[key] = "";
      });
      this.formData.labelId = [];
      this.$router.push({
        query: {},
      });
    },
    beforeUp(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("文章主图大小不能超过 2MB！");
      }
      return isLt2M;
    },
    uploadSuccess(res) {
      this.formData.picUrl = res.data;
    },
    getTag() {
      axios({
        url: `${this.$store.state.apiUrlZero}/TuZero/selectLabelTable`,
        method: "post",
      }).then((res) => {
        // console.log(res)
        if (res.data.code === 0) {
          res.data.data.forEach((item) => {
            this.articleTag.push({
              label: item.label,
              value: item.id,
            });
          });
        }
      });
    },
    subArticle() {
      this.$refs.formMain.validate((valid) => {
        if (valid) {
          let paramObj = {
              ...this.formData,
            },
            targetUrl = "";
          paramObj.labelId = paramObj.labelId.join(",");
          if (this.$route.query.sign) {
            // 修改
            targetUrl = `${this.$store.state.apiUrlZero}/TuZero/updateNews`;
            paramObj.id = this.$route.query.id;
            paramObj.newsArticleId = this.$route.query.newsArticleId;
          } else {
            // 新建
            targetUrl = `${this.$store.state.apiUrlZero}/TuZero/insertNews`;
          }
          axios({
            url: targetUrl,
            method: this.$route.query.sign ? "put" : "post",
            data: paramObj,
          }).then((res) => {
            // console.log(res)
            if (this.$route.query.sign) {
              this.$message.success("文章内容已更新");
            } else {
              this.$message.success("文章已发布");
            }
            this.resetHandle();
          });
        }
      });
    },
    // 获取对应id文章详情
    getIDDetail(id) {
      axios
        .post(`${this.$store.state.apiUrlZero}/TuZero/selectNewsArticle`, {
          id,
        })
        .then((res) => {
          this.formData.article = res.data.data.article;
        });
    },
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>

<style lang="scss" scoped>
.sub-news {
}
.mb-0 {
  margin-bottom: 0;
}
.w-100 {
  width: 100%;
}
.avatar-uploader /deep/.el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  // overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.btn-box {
  margin-top: 10px;

  .release {
    margin-bottom: 10px;
  }
}
</style>
